module.exports = __webpack_public_path__ + "img/bell-filled.f5763bd0.svg";